import AdminListTable from './lib/table';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import AppLoading from 'components/appLoading';
import PageTitle from 'components/pageTitle';

import * as S from './styles';

export default function AdminsPage() {
  const { userList, roles } = useTypedSelector((state: any) => state.Users);

  return (
    <S.Container>
      {/* Filter moved into the toolbar, so the head row this screen drew held
          nothing and is gone. */}
      <PageTitle title="Admin List" />
      <AdminListTable data={userList.data} loading={userList.loading} roles={roles.data} />

      <AppLoading loading={roles.loading} />
    </S.Container>
  );
}
